class FechaService {
  fechaHoy() {
    let me = this;
    let fecha_actual, d, m, a, hh, mm;
    let mes, dia, hora, minuto;
    fecha_actual = new Date();
    //fecha1:new Date().getDay(),
    (m = fecha_actual.getMonth()),
      (d = fecha_actual.getDate()),
      (a = fecha_actual.getFullYear()),
      (hh = fecha_actual.getHours());
    mm = fecha_actual.getMinutes();
    //console.log(d);
    if (m < 9) mes = "0" + (m + 1);
    else mes = m + 1;
    if (d < 10) dia = "0" + d;
    else dia = d;
    if (hh < 10) hora = "0" + hh;
    else hora = hh;
    if (mm < 10) minuto = "0" + mm;
    else minuto = mm;
    //me.fechad = a + "-" + mes + "-" + dia + " " + hora + ":" + minuto + ":" + fecha_actual.getSeconds();
    //me.fecha = d+'/'+(m+1)+'/'+a+' '+hh+':'+mm;
    me.fecha = a + "-" + mes + "-" + dia + " " + hora + ":" + minuto;
    return me.fecha;
  }

  formatoDate(date) {
    let a, d, m, hh, mm;
    let mes, dia, hora, minuto;
    let fecha;
    m = date.getMonth();
    d = date.getDate();
    a = date.getFullYear();
    hh = date.getHours();
    mm = date.getMinutes();
    if (m < 9) mes = "0" + (m + 1);
    else mes = m + 1;
    if (d < 10) dia = "0" + d;
    else dia = d;
    if (hh < 10) hora = "0" + hh;
    else hora = hh;
    if (mm < 10) minuto = "0" + mm;
    else minuto = mm;

    fecha = a + "-" + mes + "-" + dia + " " + hora + ":" + minuto;
    console.log(fecha);
    return fecha;
  }

  calcularEdad(fechanacimiento){
    console.log(fechanacimiento);
    var hoy = new Date()
    var fechaNac = new Date(fechanacimiento)
    var edad = hoy.getFullYear() - fechaNac.getFullYear()
    var diferenciaMeses = hoy.getMonth() - fechaNac.getMonth()
    if (
      diferenciaMeses < 0 ||
      (diferenciaMeses === 0 && hoy.getDate() < fechaNac.getDate())
    ) {
      edad--
    }
    //console.log(edad);
    return edad
  }


}
export default new FechaService();
